import React, { useState } from 'react';
import { Link } from 'react-router-dom';
const landingImages = require.context('../../assets/images', true)


export const BestCoursesCard = ({description, level, name, courseId, newCourse, number_opinions, number_students, image, id, instructor, stars, time_minutes}) => {
    const desc_length = 240;
    const descrip = (!!description)?(description.length<desc_length)?description:(description.substring(0,desc_length-1)+'...'):'';
    const [isActive, setActive] = useState(false);

    const toggleClass = () => {
        setActive(!isActive);
      };
    const star_list = []
    for (let i = 0; i < stars; i++) {
        star_list.push(<img  alt={"Yellow star"} src={landingImages(`./icons/yellow-star-icon.svg`)} className="" style={{width: "13px", height:"auto"}}/>)        
    }
    const show_correct_time = (time_minutes) =>{
       return Math.floor(time_minutes/60)+"h "+time_minutes%60+"m";
    }
    return (
            <div className='col-12 col-sm-6 col-md-6 col-lg-3 BestCourses__indicator-margin' onMouseEnter={toggleClass} onMouseLeave={toggleClass} >
               
                <div className='row mx-2 mt-2'>
                    <div className='col-12 p-0'>
                        {
                            newCourse &&
                            <div className='BestCourses__new-course-advertise'>
                                Nuevo
                            </div>
                        }
                        
                        <img alt={'Course thumbnail '+name} src={image} className='BestCourses__image' width="409" height="245" />
                        
                    </div>
                        
                </div>
                {
                    isActive
                    
                
                ? <div className='row justify-content-start align-items-center text-start mx-2 mb-2 BestCourses__container-text-active'>
                    <div className='col-12 '>
                        <div className='row'>
                            <div className='col-12'>
                                <p className='BestCourses__text mb-3'>{name}</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <p className='BestCourses__text-instructor' style={{color: "black"}}>Por <span className='BestCourses__text-color-green'>{instructor}</span></p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-1'> </div>
                            <div className='col-1'>
                                <img alt={'People icon'} src={landingImages(`./icons/clock-mini-icon.svg`)} style={{width:"18px", height:"auto"}} />
                            </div>
                            <div className='col-2 col-lg-3 px-1 px-md-1 BestCourses__course-info-text text-center'>
                                {show_correct_time(time_minutes)}
                            </div>
                            <div className='col-2 col-lg-2 px-1 px-md-1 BestCourses__course-info-text'>
                            </div>
                            <div className='col-1 px-1 px-md-1 align-items-end'>
                                <img alt={'Level icon'} src={landingImages(`./icons/level-icon.svg`)} style={{width:"18px", height:"auto"}} /> 

                            </div>
                            <div className='col-3 px-1 px-md-1  BestCourses__course-info-text'>
                                {level}
                            </div>
                        </div>
                        <div className='row text-justify'>
                            <div className='col-12 h-100'>
                                <p className='BestCourses__text-description'>{descrip}</p>
                            </div>
                        </div>
                        <div className='row justify-content-center text-center'>
                            <Link to={`/curso/${courseId}`} className='px-4 px-sm-5 text_primary fw-bold'>
                                <div className='col-10 BestCourses__button-primary mb-3'>
                                    Ver curso
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                
                : <div className='row justify-content-start align-items-center text-start mx-2 mb-2 BestCourses__container-text'>
                    <div className='col-12 '>
                        <div className='row'>
                            <div className='col-12'>
                                <p className='BestCourses__text mb-2'>{name}</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <p className='BestCourses__text-instructor'>Por {instructor}</p>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
  )
}
